import Layout from 'components/layout/Layout';
import { userBasicInfoPublicPages } from 'modules/graphqlQueries';
import { useLoadData } from 'modules/useLoadData';
import { useRouter } from 'next/router';
import { useState } from 'react';
import {
  Bid2boardLogo,
  ButtonStyled,
  IconsWrapper,
  LogoArea,
  Text,
  Wrapper,
} from 'styles/media-page.styles';
import { UserType } from 'types/UserTypes';

const getQuery = (userId: string) => `{
  user(_id: "${userId}"){
    ${userBasicInfoPublicPages}
  }
}`;

const MediaPage = (): JSX.Element => {
  const router = useRouter();
  const [bgColor, setBgColor] = useState<'dark' | 'white'>('white');

  const {
    isLoading,
    response: {
      data: { user },
    },
  } = useLoadData(getQuery);

  return (
    <Layout user={user as UserType} isLoading={isLoading}>
      <Wrapper>
        <Text>
          You can download our logos with transparent background to use in your
          article or media image.
        </Text>
        <ButtonStyled
          text={`Toggle ${bgColor === 'dark' ? 'light' : 'dark'} background`}
          kind="edit"
          onClick={() => setBgColor(bgColor === 'dark' ? 'white' : 'dark')}
        />
        <LogoArea>
          <IconsWrapper bgColor={bgColor}>
            <Bid2boardLogo src="Bid2boardGear.png" />
            <Bid2boardLogo src="Bid2board.png" />
          </IconsWrapper>
        </LogoArea>
        <ButtonStyled
          text="Download icons"
          kind="save"
          onClick={() => router.push('/bid2board-logos.zip')}
        />
      </Wrapper>
    </Layout>
  );
};

export default MediaPage;
